/** PlanGo Agent 화면 주소 (회원 서버/PC 에서 실행) */
export const AGENT_URL = (process.env.REACT_APP_AGENT_URL || 'http://localhost:3000').replace(/\/+$/, '');

/** 에이전트 화면으로 이동. email 이 있으면 쿼리로 넘긴다 */
export const goToAgent = (path = '', email = '') => {
  const url = new URL(`${AGENT_URL}${path}`);
  if (email) url.searchParams.set('email', email);
  window.location.href = url.toString();
};
